/* HavenLight theme script — packs, cart drawer, sticky bar, FAQ, gallery */
(function () {
  'use strict';

  var PREVIEW = !!window.SN_PREVIEW;
  var MONEY_FORMAT = window.SN_MONEY_FORMAT || '${{amount}}';
  var compareMap = {};   // variantId -> compare_at cents
  var imageMap = {};     // variantId -> image url

  /* ---------------- helpers ---------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);
    function fmt(n, dec, th, ds) {
      dec = dec == null ? 2 : dec; th = th || ','; ds = ds || '.';
      var num = (n / 100).toFixed(dec).split('.');
      var whole = num[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return whole + (num[1] ? ds + num[1] : '');
    }
    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }
  window.SNformatMoney = formatMoney;

  var ICON = {
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg>'
  };

  /* ---------------- cart adapter ---------------- */
  var Cart = (function () {
    var mem = { items: [], item_count: 0, total_price: 0, original_total_price: 0, total_discount: 0 };
    var nextKey = 1;
    function recalcMem() {
      // mimic Shopify automatic discounts in preview: pack % off + cheapest gift-flagged line free
      var count = 0, orig = 0, total = 0;
      var packPct = (window.SN_PREVIEW_DISCOUNT || {});
      mem.items.forEach(function (it) { count += it.quantity; });
      var amt = 0;
      if (packPct.tiers) { var ta = packPct.tiers.filter(function (x) { return count >= x.qty && x.amount; }).pop(); if (ta) amt = ta.amount; }
      var grossAll = 0; mem.items.forEach(function (it) { grossAll += it.price * it.quantity; });
      mem.items.forEach(function (it) {
        it.original_line_price = it.price * it.quantity;
        var pct = 0;
        if (packPct.tiers) { var t = packPct.tiers.filter(function (x) { return count >= x.qty; }).pop(); if (t) pct = t.pct; }
        else if (count >= 2 && packPct.pct) pct = packPct.pct;
        var line = it.original_line_price;
        if (it.properties && it.properties._gift) line = 0;
        else if (amt) line = line - Math.round(amt * line / grossAll);
        else line = Math.round(line * (1 - pct / 100));
        it.final_line_price = line;
        orig += it.original_line_price; total += line;
      });
      mem.item_count = count; mem.original_total_price = orig; mem.total_price = total; mem.total_discount = orig - total;
      return JSON.parse(JSON.stringify(mem));
    }
    function find(key) { for (var i = 0; i < mem.items.length; i++) if (mem.items[i].key === key) return i; return -1; }

    function get() {
      if (PREVIEW) return Promise.resolve(recalcMem());
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function add(items) {
      if (PREVIEW) {
        items.forEach(function (it) {
          var v = window.SN_PREVIEW_VARIANTS[it.id];
          var propKey = JSON.stringify(it.properties || {});
          var existing = mem.items.filter(function (m) { return m.variant_id === it.id && JSON.stringify(m.properties || {}) === propKey; })[0];
          if (existing) existing.quantity += it.quantity;
          else mem.items.push({ key: 'k' + (nextKey++), variant_id: it.id, product_title: v.product_title, variant_title: v.title, image: v.image, price: v.price, quantity: it.quantity, properties: it.properties || {}, url: '#' });
        });
        return Promise.resolve(recalcMem());
      }
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
      });
    }
    function change(key, qty) {
      if (PREVIEW) {
        var i = find(key);
        if (i > -1) { if (qty <= 0) mem.items.splice(i, 1); else mem.items[i].quantity = qty; }
        return Promise.resolve(recalcMem());
      }
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }
    return { get: get, add: add, change: change };
  })();

  /* ---------------- cart drawer ---------------- */
  var Drawer = {
    el: null,
    init: function () {
      this.el = $('#sn-drawer');
      if (!this.el) return;
      var self = this;
      $$('[data-sn-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); self.open(); }); });
      $$('[data-sn-cart-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      this.el.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sn-qty]');
        if (btn) {
          var key = btn.getAttribute('data-key');
          var q = parseInt(btn.getAttribute('data-sn-qty'), 10);
          self.busy(true);
          Cart.change(key, Math.max(0, q)).then(function (c) { self.render(c); }).finally(function () { self.busy(false); });
        }
      });
      Cart.get().then(function (c) { self.render(c); }).catch(function () {});
    },
    busy: function (on) { if (this.el) this.el.style.opacity = on ? '.85' : ''; },
    open: function () {
      document.documentElement.classList.add('sn-drawer-open');
      var self = this; Cart.get().then(function (c) { self.render(c); });
      var close = $('.sn-drawer__close', this.el); if (close) close.focus();
    },
    close: function () { document.documentElement.classList.remove('sn-drawer-open'); },
    render: function (cart) {
      $$('[data-sn-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.style.display = cart.item_count ? '' : 'none'; });
      if (!this.el) return;
      var body = $('.sn-drawer__body', this.el);
      var foot = $('.sn-drawer__foot', this.el);
      var countEl = $('.sn-drawer__count', this.el);
      if (countEl) countEl.textContent = cart.item_count;
      var strings = window.SN_STRINGS || {};
      if (!cart.items.length) {
        body.innerHTML = '<div class="sn-drawer__empty"><p>' + esc(strings.empty || 'Your cart is empty — your bed is still waiting.') + '</p><button type="button" class="sn-btn" data-sn-cart-close>' + esc(strings.continue_shopping || 'Keep shopping') + '</button></div>';
        $$('[data-sn-cart-close]', body).forEach(function (b) { b.addEventListener('click', function () { Drawer.close(); }); });
        foot.hidden = true; return;
      }
      foot.hidden = false;
      var totalCompare = 0;
      var html = cart.items.map(function (it) {
        var isGift = it.properties && (it.properties._gift || it.properties['_gift']);
        var bundle = it.properties && it.properties._bundle;
        var unitCompare = compareMap[it.variant_id] && compareMap[it.variant_id] > it.price ? compareMap[it.variant_id] : it.price;
        var lineCompare = unitCompare * it.quantity;
        totalCompare += lineCompare;
        var save = lineCompare - it.final_line_price;
        var img = it.image ? (it.image.indexOf('<svg') === 0 ? it.image : '<img src="' + esc(sizeImg(it.image, 160)) + '" alt="" loading="lazy" width="76" height="76">') : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="sn-line__variant">' + esc(it.variant_title) + '</div>' : '';
        var tag = isGift ? '<span class="sn-line__tag sn-line__tag--gift">' + esc(strings.gift_tag || 'Free gift') + ' · ' + esc(bundle || '') + '</span>'
          : (bundle ? '<span class="sn-line__tag">' + esc(bundle) + '</span>' : '');
        var price = it.final_line_price === 0 ? formatMoney(0) : formatMoney(it.final_line_price);
        return '<div class="sn-line">' +
          '<div class="sn-line__img">' + img + '</div>' +
          '<div><div class="sn-line__title">' + esc(it.product_title) + '</div>' + variant + tag +
          (isGift ? '' : '<div class="sn-qty"><button type="button" aria-label="Decrease" data-sn-qty="' + (it.quantity - 1) + '" data-key="' + esc(it.key) + '">−</button><span>' + it.quantity + '</span><button type="button" aria-label="Increase" data-sn-qty="' + (it.quantity + 1) + '" data-key="' + esc(it.key) + '">+</button></div>') +
          '</div>' +
          '<div class="sn-line__right"><div><div class="sn-line__price">' + price + '</div>' +
          (lineCompare > it.final_line_price ? '<div class="sn-line__was">' + formatMoney(lineCompare) + '</div>' : '') +
          (save > 0 ? '<div class="sn-line__save">' + esc(strings.save || 'Save') + ' ' + formatMoney(save) + '</div>' : '') +
          '</div><button type="button" class="sn-line__remove" aria-label="Remove" data-sn-qty="0" data-key="' + esc(it.key) + '">' + ICON.trash + '</button></div>' +
          '</div>';
      }).join('');
      body.innerHTML = html;
      var totalSave = totalCompare - cart.total_price;
      $('[data-sn-sum-save]', foot).textContent = '−' + formatMoney(Math.max(0, totalSave));
      $('[data-sn-sum-save-row]', foot).hidden = totalSave <= 0;
      $('[data-sn-sum-total]', foot).textContent = formatMoney(cart.total_price);
    }
  };

  function sizeImg(url, w) {
    if (!url || url.indexOf('data:') === 0 || url.indexOf('cdn.shopify') === -1) return url;
    return url.replace(/(\.[a-z]{3,4})(\?|$)/i, '$1$2').replace(/\?.*$/, '') + '?width=' + w;
  }

  /* ---------------- product / packs ---------------- */
  function initProduct(root) {
    var dataEl = $('[data-sn-product-json]', root);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); }
    catch (err) { console.error('[HavenLight] product data could not be read', err); return; }
    var product = data.product;
    // Build variants from Shopify's own variant JSON (robust against Liquid differences)
    if (data.variants_raw && data.variants_raw.length) {
      product.variants = data.variants_raw.map(function (v) {
        var img = v.featured_image && v.featured_image.src ? v.featured_image.src : '';
        var opts = v.options && v.options.length ? v.options : [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
        return {
          id: v.id, title: v.title, options: opts,
          price: Number(v.price) || 0,
          compare_at_price: Number(v.compare_at_price) || 0,
          available: v.available !== false,
          image: img || product.image || '',
          own_image: !!img,
          media_id: v.featured_media && v.featured_media.id ? v.featured_media.id : null
        };
      });
      var names = data.options || [];
      var ci = -1; names.forEach(function (n, j) { if (/colou?r/i.test(String(n))) ci = j; });
      if (ci > -1) {
        data.color_images = data.color_images || {};
        product.variants.forEach(function (v) {
          var c = String(v.options[ci] || '').toLowerCase();
          if (v.own_image && c && !data.color_images[c]) data.color_images[c] = v.image;
        });
      }
    }
    if (data.design_photos && product.variants) {
      // theme design photos: match slot thumbnails and gallery by colour name
      product.variants.forEach(function (v) { v.own_image = false; v.media_id = null; });
    }
    if (!product.variants || !product.variants.length) { console.error('[HavenLight] product has no variants'); return; }
    if (!product.variants.some(function (v) { return v.id === data.selected_variant; })) data.selected_variant = product.variants[0].id;
    var variants = product.variants;
    var hasVariants = variants.length > 1;
    variants.forEach(function (v) { if (v.own_image === undefined) v.own_image = !!v.image; compareMap[v.id] = v.compare_at_price || 0; imageMap[v.id] = v.image || product.image; });
    var byIdPrev = {}; variants.forEach(function (v) { byIdPrev[v.id] = v; });
    var defaultIdPrev = data.selected_variant;
    if (PREVIEW) {
      window.SN_PREVIEW_VARIANTS = {};
      variants.forEach(function (v) { window.SN_PREVIEW_VARIANTS[v.id] = { title: v.title, price: v.price, image: v.image || product.image, product_title: product.title }; });
      window.SN_PREVIEW_DISCOUNT = { tiers: data.packs.slice(1).map(function (p) {
        var full = (byIdPrev[defaultIdPrev] || variants[0]).price * p.qty;
        return { qty: p.qty, amount: p.amount_off || 0, pct: p.price > 0 ? (1 - p.price / full) * 100 : (p.discount || 0) };
      }) };
    }
    var byId = {}; variants.forEach(function (v) { byId[v.id] = v; });
    var defaultId = (variants.filter(function (v) { return v.id === data.selected_variant; })[0] || variants.filter(function (v) { return v.available; })[0] || variants[0]).id;

    var state = { pack: data.default_pack || 0, slots: {} };
    if (!data.packs || !data.packs.length) return;
    if (state.pack >= data.packs.length || state.pack < 0) state.pack = data.packs.length - 1;
    data.packs.forEach(function (p, i) {
      var n = p.qty + (p.gift ? 1 : 0);
      state.slots[i] = []; for (var k = 0; k < n; k++) state.slots[i].push(defaultId);
    });

    var packEls = $$('[data-sn-pack]', root);
    var atcBtn = $('[data-sn-atc]', root);
    var atcPrice = $('[data-sn-atc-price]', root);
    var errEl = $('[data-sn-error]', root);

    function optionHtml(selectedId) {
      return variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.id === selectedId ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' — ' + (data.strings.sold_out || 'Sold out')) + '</option>';
      }).join('');
    }
    function imgHtml(vId) {
      var src = imageMap[vId];
      if (!src) return '';
      if (src.indexOf('<svg') === 0) return src;
      return '<img src="' + esc(sizeImg(src, 120)) + '" alt="" width="42" height="42" loading="lazy">';
    }

    function packTotals(i) {
      var p = data.packs[i];
      var ids = state.slots[i];
      var paidIds = ids.slice(0, p.qty);
      var paid = 0, compare = 0;
      paidIds.forEach(function (id) { var v = byId[id]; paid += v.price; compare += Math.max(v.compare_at_price || 0, v.price); });
      if (p.gift) { var g = byId[ids[p.qty]]; compare += Math.max(g.compare_at_price || 0, g.price); }
      var now;
      if (p.amount_off > 0) {
        now = Math.max(0, paid - p.amount_off);
      } else if (p.price > 0) {
        // fixed bundle total, scaled if the chosen sizes cost more/less than the default size
        var base = byId[defaultId].price * p.qty;
        now = base > 0 ? Math.round(p.price * (paid / base)) : p.price;
      } else {
        now = Math.round(paid * (1 - (p.discount || 0) / 100));
      }
      var units = p.qty + (p.gift ? 1 : 0);
      return { now: now, compare: compare, each: Math.round(now / units), units: units };
    }

    var optNames = data.options && data.options.length ? data.options : [data.option_name || 'Option'];
    var multi = optNames.length > 1;
    var SWATCH = { white: '#f2f2ee', black: '#1f2023', green: '#6a9a62', sage: '#8fae86', grey: '#9a9ea3', gray: '#9a9ea3', blue: '#5b7db1', navy: '#2c3e63', beige: '#d9c7a6', pink: '#e7b7c0' };
    var colorIdx = -1; optNames.forEach(function (n, j) { if (/colou?r/i.test(n)) colorIdx = j; });
    function vOpts(v) { return v.options && v.options.length ? v.options : [v.title]; }
    function swatchHtml(v) {
      if (colorIdx < 0) return '';
      var c = SWATCH[String(vOpts(v)[colorIdx]).toLowerCase()] || '#ccc';
      return '<span class="sn-swatch-tile" style="background:' + c + '"></span>';
    }
    var colorImages = data.color_images || {};
    function colorImgUrl(v) {
      if (colorIdx < 0 || !v) return null;
      return colorImages[String(vOpts(v)[colorIdx]).toLowerCase()] || null;
    }
    function slotImg(vId) {
      var v = byId[vId];
      if (v && v.own_image === false && colorIdx > -1) {
        var u = colorImgUrl(v);
        return u ? '<img src="' + esc(u) + '" alt="" width="42" height="42" loading="lazy">' : swatchHtml(v);
      }
      return imgHtml(vId);
    }
    function valuesFor(j, chosen) {
      var seen = [], out = [];
      variants.forEach(function (v) {
        var o = vOpts(v);
        for (var q = 0; q < j; q++) if (o[q] !== chosen[q]) return;
        if (seen.indexOf(o[j]) === -1) { seen.push(o[j]); out.push({ val: o[j], avail: v.available }); }
        else if (v.available) out.filter(function (x) { return x.val === o[j]; })[0].avail = true;
      });
      return out;
    }
    function resolveVariant(chosen, changedIdx) {
      var exact = variants.filter(function (v) { var o = vOpts(v); return chosen.every(function (c, q) { return o[q] === c; }); })[0];
      if (exact) return exact;
      var partial = variants.filter(function (v) { var o = vOpts(v); for (var q = 0; q <= changedIdx; q++) if (o[q] !== chosen[q]) return false; return true; });
      return partial.filter(function (v) { return v.available; })[0] || partial[0] || variants[0];
    }
    function selectsHtml(id, k, label) {
      if (!multi) {
        return '<select class="sn-select" data-sn-slot="' + k + '" aria-label="' + esc(label + ' ' + optNames[0]) + '">' + optionHtml(id) + '</select>';
      }
      var cur = vOpts(byId[id]);
      return '<div class="sn-slot__selects" style="--n:' + optNames.length + '">' + optNames.map(function (name, j) {
        return '<select class="sn-select" data-sn-slot="' + k + '" data-sn-opt="' + j + '" aria-label="' + esc(label + ' ' + name) + '">' +
          valuesFor(j, cur).map(function (x) { return '<option value="' + esc(x.val) + '"' + (x.val === cur[j] ? ' selected' : '') + (x.avail ? '' : ' disabled') + '>' + esc(x.val) + '</option>'; }).join('') +
          '</select>';
      }).join('') + '</div>';
    }

    function renderSlots(i) {
      var p = data.packs[i];
      var wrap = $('[data-sn-slots]', packEls[i]);
      if (!wrap) return;
      if (!hasVariants) { wrap.innerHTML = ''; wrap.style.display = 'none'; return; }
      var html = '';
      state.slots[i].forEach(function (id, k) {
        var isGift = p.gift && k === p.qty;
        var label = isGift ? (data.strings.gift_label || 'Free gift') : (data.strings.item_label || 'Item') + ' ' + (k + 1);
        html += '<div class="sn-slot">' +
          '<div class="sn-slot__img" data-sn-slot-img>' + slotImg(id) + '</div>' +
          '<div class="sn-slot__label">' + (isGift ? '<span class="sn-free">+ FREE</span>' : '#' + (k + 1)) + '</div>' +
          selectsHtml(id, k, label) +
          '</div>';
      });
      wrap.innerHTML = html;
    }

    function updatePrices() {
      data.packs.forEach(function (p, i) {
        var t = packTotals(i);
        var el = packEls[i]; if (!el) return;
        $('[data-sn-pack-now]', el).textContent = formatMoney(t.now);
        var was = $('[data-sn-pack-was]', el);
        was.textContent = t.compare > t.now ? formatMoney(t.compare) : '';
        var each = $('[data-sn-pack-each]', el);
        if (each) each.textContent = t.units > 1 ? formatMoney(t.each) + ' ' + (data.strings.each || '/ set') : '';
      });
      var cur = packTotals(state.pack);
      if (atcPrice) atcPrice.textContent = formatMoney(cur.now);
      // hero price follows slot #1 of the selected pack
      var v = byId[state.slots[state.pack][0]];
      setHeroPrice(v);
      var stickyNow = $('[data-sn-sticky-now]'); if (stickyNow) stickyNow.textContent = formatMoney(cur.now);
      var stickyWas = $('[data-sn-sticky-was]'); if (stickyWas) stickyWas.textContent = cur.compare > cur.now ? formatMoney(cur.compare) : '';
      var stickySave = $('[data-sn-sticky-save]');
      if (stickySave) { var pct = cur.compare > cur.now ? Math.round((1 - cur.now / cur.compare) * 100) : 0; stickySave.textContent = (data.strings.save || 'Save') + ' ' + pct + '%'; stickySave.hidden = !pct; }
      var allAvail = state.slots[state.pack].every(function (id) { return byId[id].available; });
      if (atcBtn) { atcBtn.disabled = !allAvail; $('[data-sn-atc-label]', atcBtn).textContent = allAvail ? (data.strings.add_to_cart || 'Add to cart') : (data.strings.sold_out || 'Sold out'); }
      var stickySel = $('[data-sn-sticky-select]'); if (stickySel) stickySel.value = String(state.slots[state.pack][0]);
    }

    function setHeroPrice(v) {
      var now = $('[data-sn-price-now]', root), was = $('[data-sn-price-was]', root), save = $('[data-sn-price-save]', root);
      if (!now) return;
      now.textContent = formatMoney(v.price);
      var cmp = v.compare_at_price || 0;
      if (cmp > v.price) { was.textContent = formatMoney(cmp); was.hidden = false; save.textContent = (data.strings.save || 'Save') + ' ' + Math.round((1 - v.price / cmp) * 100) + '%'; save.hidden = false; }
      else { was.hidden = true; save.hidden = true; }
    }

    function selectPack(i) {
      state.pack = i;
      packEls.forEach(function (el, k) {
        el.classList.toggle('is-selected', k === i);
        var r = $('input[type=radio]', el); if (r) r.checked = k === i;
      });
      updatePrices();
    }

    packEls.forEach(function (el, i) {
      renderSlots(i);
      el.addEventListener('click', function (e) { if (e.target.closest('select')) return; if (state.pack !== i) selectPack(i); });
      el.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === el) { e.preventDefault(); selectPack(i); } });
      el.addEventListener('change', function (e) {
        var s = e.target.closest('[data-sn-slot]'); if (!s) return;
        var k = parseInt(s.getAttribute('data-sn-slot'), 10);
        if (s.hasAttribute('data-sn-opt')) {
          var j = parseInt(s.getAttribute('data-sn-opt'), 10);
          var chosen = vOpts(byId[state.slots[i][k]]).slice();
          chosen[j] = s.value;
          state.slots[i][k] = resolveVariant(chosen, j).id;
          renderSlots(i);
        } else {
          state.slots[i][k] = parseInt(s.value, 10);
          var imgBox = s.parentNode.querySelector('[data-sn-slot-img]'); if (imgBox) imgBox.innerHTML = slotImg(state.slots[i][k]);
        }
        if (k === 0) showVariantImage(state.slots[i][0]);
        updatePrices();
      });
    });

    /* gallery */
    var mainImg = $('[data-sn-main]', root);
    var thumbs = $$('[data-sn-thumb]', root);
    function showThumb(t) {
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      if (!mainImg) return;
      var full = t.getAttribute('data-full');
      if (full && full.indexOf('#') === 0) { var tpl = $(full); if (tpl) mainImg.innerHTML = tpl.innerHTML; }
      else if (full) mainImg.innerHTML = '<img src="' + esc(full) + '" alt="' + esc(t.getAttribute('data-alt') || '') + '">';
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showThumb(t); }); });
    function showVariantImage(vId) {
      var v = byId[vId]; if (!v) return;
      var t = v.media_id ? thumbs.filter(function (x) { return x.getAttribute('data-media-id') === String(v.media_id); })[0] : null;
      if (!t && colorIdx > -1) {
        var c = String(vOpts(v)[colorIdx]).toLowerCase();
        t = thumbs.filter(function (x) { return (x.getAttribute('data-color') || '') === c; })[0];
      }
      if (t) showThumb(t);
    }

    /* add to cart */
    function addPack() {
      var p = data.packs[state.pack];
      var ids = state.slots[state.pack];
      var label = p.label;
      var counts = {};
      ids.slice(0, p.qty).forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) {
        var it = { id: parseInt(id, 10), quantity: counts[id] };
        if (data.packs.length > 1 && p.qty > 1) it.properties = { _bundle: label };
        return it;
      });
      if (p.gift) items.push({ id: ids[p.qty], quantity: 1, properties: { _bundle: label, _gift: 'true' } });
      if (errEl) errEl.textContent = '';
      var btns = [atcBtn, $('[data-sn-sticky-atc]')].filter(Boolean);
      btns.forEach(function (b) { b.disabled = true; });
      Cart.add(items).then(function () { return Cart.get(); }).then(function (c) { Drawer.render(c); Drawer.open(); })
        .catch(function (err) { if (errEl) errEl.textContent = err.message; })
        .finally(function () { btns.forEach(function (b) { b.disabled = false; }); updatePrices(); });
    }
    if (atcBtn) atcBtn.addEventListener('click', addPack);
    $$('[data-sn-scroll-buy]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); var t = $('[data-sn-buybox]', root); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }); });

    /* sticky bar */
    var sticky = $('[data-sn-sticky]');
    if (sticky) {
      var sel = $('[data-sn-sticky-select]', sticky);
      if (sel) {
        if (!hasVariants) sel.remove();
        else {
          sel.innerHTML = optionHtml(state.slots[state.pack][0]);
          sel.addEventListener('change', function () {
            var id = parseInt(sel.value, 10);
            state.slots[state.pack] = state.slots[state.pack].map(function () { return id; });
            renderSlots(state.pack); showVariantImage(id); updatePrices();
          });
        }
      }
      var sAtc = $('[data-sn-sticky-atc]', sticky); if (sAtc) sAtc.addEventListener('click', addPack);
      if ('IntersectionObserver' in window && atcBtn) {
        var footer = document.querySelector('.sn-footer');
        var atcVisible = true, footerVisible = false;
        var upd = function () { var past = !atcVisible && atcBtn.getBoundingClientRect().top < 0; sticky.classList.toggle('is-visible', past && !footerVisible); };
        new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; upd(); }).observe(atcBtn);
        if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; upd(); }).observe(footer);
      }
    }

    selectPack(state.pack);
  }

  /* ---------------- FAQ (one open at a time) ---------------- */
  function initFaq() {
    $$('[data-sn-faq]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var q = e.target.closest('.sn-faq__q'); if (!q) return;
        var item = q.parentNode, open = item.classList.contains('is-open');
        $$('.sn-faq__item', list).forEach(function (x) { x.classList.remove('is-open'); $('.sn-faq__q', x).setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---------------- newsletter (preview only) ---------------- */
  function initNews() {
    if (!PREVIEW) return;
    $$('[data-sn-news]').forEach(function (f) {
      f.addEventListener('submit', function (e) { e.preventDefault(); var m = $('.sn-news-msg', f.parentNode) || document.createElement('p'); m.className = 'sn-news-msg'; m.textContent = 'Preview only — on your store this signs people up to Shopify Customers.'; f.parentNode.appendChild(m); });
    });
  }

  function boot() {
    try { Drawer.init(); } catch (e) { console.error('[HavenLight] cart drawer', e); }
    $$('[data-sn-product]').forEach(function (r) { try { initProduct(r); } catch (e) { console.error('[HavenLight] product', e); } });
    try { initFaq(); } catch (e) { console.error('[HavenLight] faq', e); }
    try { initNews(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ---------------- sale countdown (counts to a real end date set in the theme editor) ---------------- */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function start(el) {
    if (el._snTimer) clearInterval(el._snTimer);
    var end = Date.parse(el.getAttribute('data-end'));
    var out = el.querySelector('[data-sn-countdown-time]');
    if (isNaN(end) || !out) { el.hidden = true; return; }
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; clearInterval(el._snTimer); return; }
      var s = Math.floor(ms / 1000);
      var h = Math.floor(s / 3600); s -= h * 3600;   /* total hours, no days */
      var m = Math.floor(s / 60); s -= m * 60;
      out.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      el.hidden = false;
    }
    tick();
    el._snTimer = setInterval(tick, 1000);
  }
  function init(root) { Array.prototype.forEach.call((root || document).querySelectorAll('[data-sn-countdown]'), start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
